export const isDisclaimerShown = () =>
  localStorage.getItem("isDisclaimerShown");

export const setIsDisclaimerShown = () => {
  localStorage.setItem("isDisclaimerShown", "true");
};
